import { EAccessDataStatus } from "@/frontend/features/Company/model/types/types";
import { NoAiDataContainer } from "@/frontend/features/Company/ui/NoAiDataContainer/NoAiDataContainer";
import { UnlockIcon } from "@/frontend/shared/assets/icons/UnlockIcon";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { Typography } from "@/frontend/shared/ui/Typography";
import { SectionContentWrapper } from "@/frontend/widgets/SectionContentWrapper/SectionContentWrapper";
import styles from "./TeamSectionByAi.module.scss";
import { CaretDownIcon, CheckIcon } from "@/frontend/shared/assets/icons";
import clsx from "clsx";
import { LinkedInLettersIcon } from "@/frontend/shared/assets/icons/LinkedInLettersIcon";
import { mockTeamData } from "../../../const/mock";
import { useState } from "react";
import { Loader } from "@/frontend/shared/ui/Loader/Loader";
import { SectionLoader } from "../../Section/SectionLoader/SectionLoader";
export type TTeamSectionByAiProps = {
  dataStatusFromAccess: EAccessDataStatus;
  companyName?: string | null;
  logoUrl?: string | null;
  onConfirmRequestDataAccess?: () => void;
  isLoadingRequestAccess?: boolean;
  aiTeamData?: any[];
  isLoadingAiTeamData: boolean;
  onEdit?: () => void;
};

export function TeamSectionByAi({
  dataStatusFromAccess,
  companyName,
  logoUrl,
  onConfirmRequestDataAccess,
  isLoadingRequestAccess,
  aiTeamData,
  isLoadingAiTeamData: isLoading,
  onEdit
}: TTeamSectionByAiProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  function showTeamDataContent() {
    if (
      dataStatusFromAccess === EAccessDataStatus.FULL_DATA ||
      dataStatusFromAccess === EAccessDataStatus.PROFILE_DATA ||
      dataStatusFromAccess === EAccessDataStatus.NO_FOUNDER ||
      (!!aiTeamData && aiTeamData?.length > 0) ||
      isLoading
    ) {
      switch (true) {
        case !!aiTeamData && aiTeamData?.length > 0:
          return (
            <div className={clsx(styles.innoveraBlock, styles.innoveraTeamBlock)}>
              <div className={styles.innoveraBlockTitle}>
                <div className={styles.innoveraSubBlockTitle} aria-level={7} role="heading">
                  <Typography variant="label-2" color="greyscale700">
                    People
                  </Typography>
                  <Typography variant="label-2" color="greyscale500">
                    {aiTeamData?.length}
                  </Typography>
                </div>
              </div>
              <div className={styles.cardsContainer}>
                {aiTeamData?.slice(0, isExpanded ? aiTeamData?.length : 6)?.map((item: any, index: number) => {
                  const itemTitle = item.firstName + " " + item.lastName + "\n" + item.title;
                  return (
                    <div className={styles.teamCard} key={`${item.name}${index}`} title={itemTitle}>
                      <div className={styles.subTeamCardContainer}>
                        {item.imageUrl || item.profilePhotoUrl ? (
                          <img alt="" src={item.imageUrl || item.profilePhotoUrl} className={styles.imageContainer} />
                        ) : (
                          <div className={styles.imageContainer} />
                        )}
                        <div className={styles.infoContainer}>
                          <div className={styles.nameContainer}>
                            <Typography variant="label-4" color="greyscale900">
                              {item.firstName} {item.lastName}
                            </Typography>
                          </div>
                          <Typography variant="body-3" color="greyscale600" className={styles.title}>
                            {item.title}
                          </Typography>
                        </div>
                      </div>
                      {item.linkedInUrl && (
                        <a className={styles.linkedInIcon} href={item.linkedInUrl} target="_blank" rel="noreferrer">
                          <LinkedInLettersIcon />
                        </a>
                      )}
                    </div>
                  );
                })}
              </div>
              {aiTeamData?.length > 6 && (
                <NormalButton
                  variant="primary"
                  size="small"
                  className={styles.seeMoreBtn}
                  onClick={() => setIsExpanded((prev) => !prev)}
                >
                  <CaretDownIcon className={clsx(styles.caretDownIcon, isExpanded && styles.seeMoreBtnIconActive)} />
                  {isExpanded ? "Hide" : "Show more"}
                </NormalButton>
              )}
            </div>
          );
        case isLoading:
          return <SectionLoader />;

        case aiTeamData?.length === 0:
          return <NoAiDataContainer section="Team" name={companyName || "Company"} onAddDataClick={onEdit} />;
      }
    }
    if (dataStatusFromAccess === EAccessDataStatus.NO_ACCESS) {
      return (
        <div className={styles.innoveraWhiteBlock}>
          <div className={styles.cardsContainer}>
            {mockTeamData.slice(0, 6).map((item: any, index: number) => (
              <div className={styles.teamCard} key={`${item.name}${index}`}>
                <div className={styles.subTeamCardContainer}>
                  <div className={styles.imageContainer} />
                  <div className={styles.infoContainer}>
                    <div className={styles.nameContainer}>
                      <Typography variant="label-4" color="greyscale900">
                        {item.firstName} {item.lastName}
                      </Typography>
                    </div>
                    <Typography variant="body-3" color="greyscale600" className={styles.title}>
                      {item.title}
                    </Typography>
                  </div>
                </div>
                {item.linkedInUrl && (
                  <a className={styles.linkedInIcon} href={item.linkedInUrl} target="_blank" rel="noreferrer">
                    <LinkedInLettersIcon />
                  </a>
                )}
              </div>
            ))}
          </div>
          <div className={styles.innoveraWhiteBlockNoAccess}>
            <NormalButton
              variant="primary"
              size="medium"
              className={styles.requestButton}
              onClick={onConfirmRequestDataAccess}
              isSubmitting={isLoadingRequestAccess}
            >
              <UnlockIcon />
              <Typography variant="label-4" color="greyscale100">
                Request Data Access
              </Typography>
            </NormalButton>
          </div>
        </div>
      );
    }
    if (dataStatusFromAccess === EAccessDataStatus.PENDING_REQUEST) {
      return (
        <div className={styles.innoveraWhiteBlock}>
          <div className={styles.cardsContainer}>
            {mockTeamData.slice(0, 6).map((item: any, index: number) => (
              <div className={styles.teamCard} key={`${item.name}${index}`}>
                <div className={styles.subTeamCardContainer}>
                  <div className={styles.imageContainer} />
                  <div className={styles.infoContainer}>
                    <div className={styles.nameContainer}>
                      <Typography variant="label-4" color="greyscale900">
                        {item.firstName} {item.lastName}
                      </Typography>
                    </div>
                    <Typography variant="body-3" color="greyscale600" className={styles.title}>
                      {item.title}
                    </Typography>
                  </div>
                </div>
                {item.linkedInUrl && (
                  <a className={styles.linkedInIcon} href={item.linkedInUrl} target="_blank" rel="noreferrer">
                    <LinkedInLettersIcon />
                  </a>
                )}
              </div>
            ))}
          </div>
          <div className={styles.innoveraWhiteBlockNoAccess}>
            <NormalButton variant="primary" size="medium" className={styles.requestButtonSent}>
              <CheckIcon />
              <Typography variant="label-4" color="greyscale100">
                Access Request Sent
              </Typography>
            </NormalButton>
          </div>
          ;
        </div>
      );
    }
  }

  return (
    <SectionContentWrapper isByInnovera={false} companyName={companyName} companyLogoSrc={logoUrl}>
      {showTeamDataContent()}
    </SectionContentWrapper>
  );
}
